import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { QrCode, ArrowLeft } from 'lucide-react';
import { DERNIERE_MAJ } from '../legalInfo';

export const DOCUMENTS = [
  { to: '/mentions-legales', label: 'Mentions légales' },
  { to: '/cgu', label: 'CGU' },
  { to: '/cgv', label: 'CGV' },
  { to: '/confidentialite', label: 'Confidentialité' },
  { to: '/sous-traitance', label: 'Sous-traitance (RGPD)' },
];

// Affiche une information légale, ou un marqueur rouge bien visible tant que
// la valeur n'a pas été renseignée dans legalInfo.js. Volontairement voyant :
// une mention légale incomplète ne doit pas passer inaperçue en production.
export function Champ({ valeur, attendu }) {
  if (valeur) return <>{valeur}</>;
  return <span className="legal-todo">[à compléter : {attendu}]</span>;
}

export function Section({ titre, children }) {
  return (
    <section className="legal-section">
      <h2>{titre}</h2>
      {children}
    </section>
  );
}

export default function LegalPage({ titre, chapo, children }) {
  useEffect(() => {
    document.title = `${titre} — Jalonne`;
    window.scrollTo(0, 0);
    return () => { document.title = 'Jalonne — Suivi de chantier'; };
  }, [titre]);

  return (
    <div className="legal-page">
      <div className="legal-topbar">
        <Link to="/" className="lp-brand" style={{ fontSize: '1rem' }}>
          <span className="lp-brand-mark" style={{ width: 28, height: 28 }}><QrCode size={16} /></span>
          Jalonne
        </Link>
        <Link to="/" className="legal-back"><ArrowLeft size={14} /> Retour à l'accueil</Link>
      </div>

      <main className="legal-body">
        <h1>{titre}</h1>
        <p className="legal-date">Dernière mise à jour : {DERNIERE_MAJ}</p>
        {chapo && <p className="legal-chapo">{chapo}</p>}
        {children}
      </main>

      <nav className="legal-nav" aria-label="Documents légaux">
        {DOCUMENTS.map(d => (
          <Link key={d.to} to={d.to}>{d.label}</Link>
        ))}
      </nav>
    </div>
  );
}
